import React, { useState, useEffect } from 'react';
import useFetch from './useFetch';
import { domain } from './Domain';
import useApiRequest from './useApiRequest'
import { toast, ToastContainer, Slide } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "../css/ProductForm.css"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const CONDITIONS = [
    { value: "New with warranty (Original Packaging)", label: "New with warranty (Original Packaging)" },
    { value: "Never been used (Not in Original Packaging)", label: "Never been used (Not in Original Packaging)" },
    { value: "Refurbished", label: "Refurbished" }
];
  
const CONTACTS = [
    { value: "2NO + 2NC", label: "2NO + 2NC" },
    { value: "1NO + 1 NC", label: "1NO + 1 NC" },
    { value: "NO", label: "NO" },
    { value: "3NO + 1NC", label: "3NO + 1NC" },
    { value: "2NO + 2NC", label: "2NO + 2NC" },
    { value: "0NO + 4NC", label: "0NO + 4NC" }
];
  
const MOUNTING_LOCATION = [
    { value: "FRONT", label: "FRONT" },
    { value: "SIDE", label: "SIDE" }
];
  
const NO_OF_POLES = [
    { value: "SINGLE", label: "SINGLE" },
    { value: "DOUBLE", label: "DOUBLE" },
    { value: "THREE", label: "THREE" },
    { value: "FOUR", label: "FOUR" }
];
  
const MECHANISM = [
    { value: "NPN NO", label: "NPN NO" },
    { value: "NPN NC", label: "NPN NC" },
    { value: "NPN NO+NC", label: "NPN NO+NC" },
    { value: "PNP NO", label: "PNP NO" },
    { value: "PNP NC", label: "PNP NC" },
    { value: "PNP NO+NC", label: "PNP NO+NC" },
    { value: "SCR Controllable Silicon NO", label: "SCR Controllable Silicon NO" },
    { value: "SCR Controllable Silicon NC", label: "SCR Controllable Silicon NC" },
    { value: "Voltage output", label: "Voltage output" },
    { value: "Line-driver output", label: "Line-driver output" }
];
  
const SIZE = [
    { value: "M8 2mm", label: "M8 2mm" },
    { value: "M12 4mm", label: "M12 4mm" },
    { value: "M18 5mm", label: "M18 5mm" },
    { value: "M20 8mm", label: "M20 8mm" },
    { value: "M22 10mm", label: "M22 10mm" },
    { value: "M30 15mm", label: "M30 15mm" }
];
  
const COIL_VOLTAGE = [
    { value: "12VDC", label: "12VDC" },
    { value: "24VDC", label: "24VDC" },
    { value: "110VAC", label: "110VAC" },
    { value: "220VAC", label: "220VAC" },
    { value: "380-400VAC", label: "380-400VAC" }
];

const PRODUCT_FORM_INITIAL = {
    category: '',
    part_number: '',
    item_code: '',
    brand: '',
    product_name: '',
    power: '',
    current_from: '',
    current_to: '',
    watts: '',
    ohms: '',
    pressure_range_from: '',
    pressure_range_to: '',
    voltage: '',
    coil_voltage: '',
    pulse_per_revolution: '',
    images: [],
    no_of_poles: '',
    mechanism: '',
    mounting_location: '',
    contacts: '',
    size: '',
    condition: '',
    cost_price: '',
    selling_price: '',
    qty: '',
    details: '',
    datasheet: [],
};

export const notify = (message, type) => {
    let toastType;
    switch(type) {
        case 'success':
            toastType = toast.success;
            break;
        case 'error':
            toastType = toast.error;
            break;
        case 'info':
            toastType = toast.info;
            break;
        default:
            toastType = toast.info;
            break;
    }

    toastType(
        message, {
            position: 'bottom-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        }
    );
};

  

const ProductForm = ({ editingId, selected, fetchProducts }) => {
    const { postRequest, putRequest } = useApiRequest();
    const { data, loading, error } = useFetch(`${domain}/product-dropdowns`);
    const [load, setLoad] = useState(false);
    const [formData, setFormData] = useState(PRODUCT_FORM_INITIAL);

    const [images, setImages] = useState([]);
    const [datasheets, setDatasheets] = useState([]);

    const modules = {
        toolbar: [
            [{header: [1,2,3,4,5,6, false]}],
            [{font: []}],
            [{size: []}],
            [{color: []}],
            [{background: []}],
            ['bold','italic','underline','strike','blockquote'],
            [
                {"list": "ordered"},
                {"list": "bullet"},
                {"indent": "-1"},
                {"indent": "+1"}
            ],
            ["link","image","video"],
            ["clean"],
        ]
    }

    const handleChange = (e) => {
        if (e.target.name === 'images') {
            setImages([...images, ...e.target.files]);
        }else if(e.target.name === "datasheet"){
            setDatasheets([...datasheets, ...e.target.files]);
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };

    const buildMultipartBody = () => {
        const fd = new FormData();
        const skip = new Set(['images', 'datasheet']);

        for (const key of Object.keys(formData)) {
            if (skip.has(key)) continue;
            const val = formData[key];
            if (editingId) {
                if (val !== null && val !== undefined && val !== '') {
                    fd.append(key, val);
                }
            } else {
                fd.append(
                    key,
                    val === null || val === undefined ? '' : val
                );
            }
        }

        images.forEach((file) => fd.append('images', file));
        datasheets.forEach((file) => fd.append('datasheet', file));
        return fd;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        try {
            const body = buildMultipartBody();
            if (editingId) {
                const res = await putRequest(
                    `${domain}/products/${editingId}`,
                    body
                );
                if (res) {
                    notify('Product updated successfully', 'success');
                    if (typeof fetchProducts === 'function') fetchProducts();
                }
            } else {
                const res = await postRequest(`${domain}/products`, body);
                if (res) {
                    notify('Product added successfully', 'success');
                    setFormData({ ...PRODUCT_FORM_INITIAL });
                    setImages([]);
                    setDatasheets([]);
                    e.target.reset();
                }
            }
        } finally {
            setLoad(false);
        }
    };

    useEffect(() => {
        if (!editingId || !selected) return;
        const fk = (v) =>
            v !== null && v !== undefined && v !== '' ? String(v) : '';
        setFormData({
            ...PRODUCT_FORM_INITIAL,
            ...selected,
            category: fk(selected.category),
            brand: fk(selected.brand),
            power: fk(selected.power),
            voltage: fk(selected.voltage),
            pulse_per_revolution: fk(selected.pulse_per_revolution),
        });
    }, [editingId, selected]);

    return (
        <div className="pf-page">
            <ToastContainer position="bottom-right" transition={Slide} />
            {loading && (
                <div className="pf-loading card border-0 shadow-sm">
                    <div className="card-body text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading form…</span>
                        </div>
                        <p className="text-secondary mb-0 mt-3">Loading options…</p>
                    </div>
                </div>
            )}
            {error && !loading && (
                <div className="alert alert-danger" role="alert">
                    Could not load product options: {error}
                </div>
            )}
            {data && (
            <div className="pf-shell card border-0 shadow-sm">
                <div className="card-body p-3 p-md-4">
                <header className="pf-header mb-3">
                    <h2 className="pf-title h5 mb-1">
                        {editingId ? 'Edit product' : 'Add product'}
                    </h2>
                    <p className="pf-subtitle text-secondary small mb-0">
                        {editingId
                            ? 'Update details and save. Files are managed from the product list when editing.'
                            : 'Required fields depend on category. Add at least one image for the main photo.'}
                    </p>
                </header>
                <form onSubmit={handleSubmit} className="pf-form" encType="multipart/form-data">
                    <div className="pf-columns">
                    <div className="pf-column">
                        <div className='d-flex gap-2'>
                            <div className='w-50 flex-grow-1'>
                                <label>Category</label>
                                <select name="category" value={formData.category} onChange={handleChange}>
                                    <option value="">Select Category</option>
                                    {data.all_categories.map((category) => (
                                    <option key={category.id} value={category.id}>
                                        {category.name}
                                    </option>
                                    ))}
                                </select>
                            </div>
                            <div className='w-50 flex-grow-1'>
                                <label>Brand:</label>
                                <select name="brand" value={formData.brand} onChange={handleChange}>
                                    <option value="">Select Brand</option>
                                    {data.all_brands.map((brand) => (
                                        <option key={brand.id} value={brand.id}>
                                            {brand.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div>
                            <label>Product Name:</label>
                            <input
                                type="text"
                                name="product_name"
                                placeholder='product name'
                                value={formData.product_name}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label>Part Number:</label>
                            <input
                                type="text"
                                name="part_number"
                                placeholder='product part number'
                                value={formData.part_number}
                                onChange={handleChange}
                            /> 
                        </div>
                        <div>
                            <label>Item Code:</label>
                            <input
                                type="text"
                                name="item_code"
                                placeholder='item code'
                                value={formData.item_code}
                                onChange={handleChange}
                            />
                        </div>
                        {(formData.category === "1" || formData.category === "2" || formData.category === "4") &&
                        <div>
                            <label>Power:</label>
                            <select name="power" value={formData.power} onChange={handleChange}>
                            <option value="">Select Power</option>
                                {data.all_power.map((power) => (
                                <option key={power.id} value={power.id}>
                                    {power.name}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "12" || formData.category === "16") &&
                        <div className='d-flex gap-2'>
                            <div className='w-50 flex-grow-1'>
                                <label>Current From:</label>
                                <input
                                    type="number"
                                    name="current_from"
                                    placeholder='current from'
                                    value={formData.current_from}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='w-50 flex-grow-1'>
                                <label>Current To:</label>
                                <input
                                    type="number"
                                    name="current_to"
                                    placeholder='current to'
                                    value={formData.current_to}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        }
                        {(formData.category === "13" || formData.category === "15" || formData.category ==="19") &&
                        <div>
                            <label>Watts:</label>
                            <input
                                type="number"
                                name="watts"
                                placeholder='watts'
                                value={formData.watts}
                                onChange={handleChange}
                            />
                        </div>
                        }
                        {(formData.category === "18") &&
                        <div>
                            <label>Ohms:</label>
                            <input
                                type="number"
                                name="ohms"
                                placeholder='ohms'
                                value={formData.ohms}
                                onChange={handleChange}
                            />
                        </div>
                        }
                        {(formData.category === "20") &&
                        <div className='d-flex gap-2'>
                            <div className='w-50 flex-grow-1'>
                                <label>Pressure Range From:</label>
                                <input
                                    type="number"
                                    name="pressure_range_from"
                                    placeholder='pressure from'
                                    value={formData.pressure_range_from}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='w-50 flex-grow-1'>
                                <label>Pressure Range To:</label>
                                <input
                                    type="number"
                                    name="pressure_range_to"
                                    placeholder='pressure to'
                                    value={formData.pressure_range_to}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        }
                        {(formData.category === "5" || formData.category === "19") &&
                        <div>
                            <label>Voltage:</label>
                            <select name="voltage" value={formData.voltage} onChange={handleChange}>
                                <option value="">Select Voltage</option>
                                {data.all_voltage.map((voltage) => (
                                <option key={voltage.id} value={voltage.id}>
                                    {voltage.name}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {formData.category === "8" &&
                        <div>
                            <label>Coil Voltage:</label>
                            <select name="coil_voltage" value={formData.coil_voltage} onChange={handleChange}>
                                <option value="">Select Coil Voltage</option>
                                {COIL_VOLTAGE.map((voltage) => (
                                <option key={voltage.value} value={voltage.value}>
                                    {voltage.label}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "8") &&
                        <div>
                            <label>Pulse per revolution</label>
                            <select name="pulse_per_revolution" value={formData.pulse_per_revolution} onChange={handleChange}>
                                <option value="">Select pulse per revolution</option>
                                {data.all_pulses_per_revolution.map((pulse) => (
                                <option key={pulse.id} value={pulse.id}>
                                    {pulse.name}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "5" || formData.category === "6" || formData.category === "7") &&
                        <div>
                            <label>No. of Poles:</label>
                            <select name="no_of_poles" value={formData.no_of_poles} onChange={handleChange}>
                                <option value="">Select Number of Poles</option>
                                {NO_OF_POLES.map((poles) => (
                                <option key={poles.value} value={poles.value}>
                                    {poles.label}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "8" || formData.category === "9" || formData.category === "10") &&
                        <div>
                            <label>Mechanism:</label>
                            <select name="mechanism" value={formData.mechanism} onChange={handleChange}>
                                <option value="">Select Mechanism</option>
                                {MECHANISM.map((mech) => (
                                <option key={mech.value} value={mech.value}>
                                    {mech.label}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "21") &&
                        <div>
                            <label>Mounting Location:</label>
                            <select name="mounting_location" value={formData.mounting_location} onChange={handleChange}>
                                <option value="">Select Mounting Location</option>
                                {MOUNTING_LOCATION.map((location) => (
                                <option key={location.value} value={location.value}>
                                    {location.label}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "9" || formData.category === "21") &&
                        <div>
                            <label>Contacts:</label>
                            <select name="contacts" value={formData.contacts} onChange={handleChange}>
                                <option value="">Select Contacts</option>
                                {CONTACTS.map((contact) => (
                                <option key={contact.value} value={contact.value}>
                                    {contact.label}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        {(formData.category === "9") &&
                        <div>
                            <label>Size</label>
                            <select name="size" value={formData.size} onChange={handleChange}>
                                <option value="">Select size</option>
                                {SIZE.map((size) => (
                                <option key={size.value} value={size.value}>
                                    {size.label}
                                </option>
                                ))}
                            </select>
                        </div>
                        }
                        <div>
                            <label>Condition:</label>
                            <select name="condition" value={formData.condition} onChange={handleChange}>
                                <option value="">Select Condition</option>
                                {CONDITIONS.map((condition) => (
                                <option key={condition.value} value={condition.value}>
                                    {condition.label}
                                </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="pf-column">
                        <div className='d-flex gap-2'>
                            <div>
                                <label>Cost Price:</label>
                                <input
                                    type="number"
                                    name="cost_price"
                                    placeholder='product cost price'
                                    value={formData.cost_price}
                                    min={1}
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <label>Selling Price:</label>
                                <input
                                    type="number"
                                    name="selling_price"
                                    min={1}
                                    placeholder='product selling price'
                                    value={formData.selling_price}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div>
                            <label>Quantity:</label>
                            <input
                                type="number"
                                name="qty"
                                placeholder='product quantity'
                                value={formData.qty}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label>Details:</label>
                            <textarea
                                className='d-none'
                                name="details"
                                value={formData.details}
                                placeholder='product description'
                                onChange={handleChange}
                            />
                            <ReactQuill 
                                theme="snow" 
                                value={formData.details} // Set the value from notificationData
                                onChange={(content) => {
                                    if(content !=="<p><br></p>"){
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            details: content // Update the 'value' property in notificationData
                                        }));
                                    }else{
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            details: "" // Update the 'value' property in notificationData
                                        }));
                                    }
                                }}
                                className="editor-input"
                                placeholder="Product description (shown on the storefront)…"
                                modules={modules}
                            />
                        </div>
                        {!editingId &&
                        <div>
                            <label>Add Product Datasheet:</label>
                            <input
                                type="file"
                                name="datasheet"
                                className='border-0'
                                accept='application/pdf'
                                multiple
                                onChange={handleChange}
                                /*
                                onChange={(e) =>
                                setFormData({ ...formData, datasheet: e.target.files[0] })
                                }
                                */
                            />
                        </div>
                        }
                        {!editingId &&
                        <div>
                            <label>Add Product Images:</label>
                            <input
                                type="file"
                                name="images"
                                className='border-0'
                                multiple
                                accept='image/*'
                                onChange={handleChange}
                            />
                        </div>
                        }
                        <div className="pf-actions">
 {editingId ? (
                        <button className="btn btn-primary px-4" type="submit" disabled={load}>
                            {load ? 'Saving…' : 'Save changes'}
                        </button>
                        ) : (
                        <button className="btn btn-primary px-4" type="submit" disabled={load}>
                            {load ? 'Adding…' : 'Add product'}
                        </button>
                        )}
                        </div>
                    </div>
                    </div>
                </form>
                </div>
            </div>
            )}
        </div>
    );
};

export default ProductForm;
